import { Component } from '@angular/core';

@Component({
  selector: 'app-zipcode-confirmation-dialog',
  templateUrl: './zipcode-confirmation-dialog.component.html',
  styleUrls: ['./zipcode-confirmation-dialog.component.scss']
})
export class ZipcodeConfirmationDialogComponent {

}
